import { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { getDashboardByType, getDashboardById, getSitemap } from './dashboard.services'
import { DashboardType } from './dashboard.types'

export const useDashboardById = (dashboardId: string) => {
  const router = useRouter()

  const queryKey = ['dashboard', dashboardId]
  const queryFunc = () => getDashboardById({ dashboardId })
  const queryOptions = {
    refetchOnWindowFocus: false,
    staleTime: 4 * 60 * 60 * 1000,
    enabled: !!dashboardId,
    onError: (err: AxiosError) => {
      if (err.response && err.response.status === 404) router.push('/404')
      if (err.response && err.response.status >= 500) router.push('/500')
    },
  }
  const { data: dashboard, ...rest } = useQuery(queryKey, queryFunc, queryOptions)

  return { dashboard, ...rest }
}

type UseDashboardArgs = {
  type: DashboardType
}
export const useDashboardByType = ({ type }: UseDashboardArgs) => {
  const router = useRouter()

  const queryKey = ['dashboard', `type:${type}`]
  const queryFunc = () => getDashboardByType({ type })
  const queryOptions = {
    refetchOnWindowFocus: false,
    staleTime: 4 * 60 * 60 * 1000,
    onError: (err: AxiosError) => {
      if (err.response && err.response.status === 404) router.push('/404')
      if (err.response && err.response.status >= 500) router.push('/500')
    },
  }
  const { data, ...rest } = useQuery(queryKey, queryFunc, queryOptions)

  return { dashboards: data?.results, ...rest }
}

export const useSitemap = () => {
  const router = useRouter()

  const queryKey = ['sitemap']
  const queryFunc = getSitemap

  const queryOptions = {
    refetchOnWindowFocus: false,
    staleTime: 8 * 60 * 60 * 1000,
    retries: 3,
    onError: (err: AxiosError) => {
      if (err.response && err.response.status === 404) router.push('/404')
      if (err.response && err.response.status >= 500) router.push('/500')
    },
  }
  const { data, ...rest } = useQuery(queryKey, queryFunc, queryOptions)

  return { sitemap: data?.results?.[0], ...rest }
}
